import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import LabeledTextfield from '../molecules/LabeledTextfield';
import SectionDivider from '../molecules/SectionDivider';

//Returning the component
class FormCompany extends Component {
	render() {
		return (
			<div className="formCompany margin-b-md">
				<SectionDivider heading="Company information" />
				<form onSubmit={this.props.handleFormSubmit} className={`form ${this.props.formWrapperClassType}`}>
					<div className="row">
						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* Company name */}
							<LabeledTextfield
								formGroupClassType={this.props.formGroupClassType}
								labelFor="companyName"
								labelText="Company name"
								labelId="companyName"
								textfieldClassType={this.props.textfieldClassType}
								textfieldId="companyName"
								textfieldPlaceholder={this.props.companyName}
								textfieldName='companyNameInput'
								textfieldOnChange={this.props.companyNameOnChange}
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageCompanyName}
								required={true}
							/>
						</div>
						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* Company size */}
							<LabeledTextfield
								formGroupClassType={this.props.formGroupClassType}
								inputType="number"
								labelFor="companySize"
								labelText="Company size"
								labelId="companySize"
								textfieldClassType={this.props.textfieldClassType}
								textfieldId="companySize"
								textfieldPlaceholder={this.props.companySize}
								textfieldName='companySizeInput'
								textfieldOnChange={this.props.companySizeOnChange}
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageCompanySize}
								required={true}
							/>
						</div>
						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* Company website */}
							<LabeledTextfield
								formGroupClassType={this.props.formGroupClassType}
								labelFor="companyWebsite"
								labelText="Company website"
								labelId="companyWebsite"
								textfieldClassType={this.props.textfieldClassType}
								textfieldId="companyWebsite"
								textfieldPlaceholder={this.props.companyWebsite}
								textfieldName='companyWebsiteInput'
								textfieldOnChange={this.props.companyWebsiteOnChange}
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageCompanyWebsite}
								required={true}
							/>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

//Making sure that it has a text property when it's declared
FormCompany.propTypes = {
	test: PropTypes.string, //Write some props here if needed, just using this to not have errors
}

export default FormCompany;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormCompany.jsx